(() => {
  if (window.monoreeAppAccessibilityInstalled) return;
  window.monoreeAppAccessibilityInstalled = true;
  const copy = JSON.parse(document.getElementById('MonoreeAppCopy')?.textContent || '{}');
  const locale = (document.documentElement.lang || 'en').split('-')[0];
  const countryNames = typeof Intl.DisplayNames === 'function'
    ? new Intl.DisplayNames([locale], { type: 'region' }) : null;
  const widgets = '.jdgm-widget, .jdgm-carousel-wrapper, .jdgm-write-review-modal';
  const schemaSelector = 'script.jdgm-server-jld[type="application/ld+json"]';
  const watched = new WeakSet();
  const schemaText = new WeakMap();
  const reviewErrorIds = new WeakMap();
  let reviewErrorSequence = 0;
  const pendingReviews = new Set();
  const pendingSchemas = new Set();
  let pendingChat = false;
  const types = { Toode: 'Product', Koondhinnang: 'AggregateRating', Arvustus: 'Review', Hinnang: 'Rating', Isik: 'Person' };
  let scheduled = false;

  function attribute(node, name, value) {
    if (value && node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function watch(root, changed) {
    if (watched.has(root)) return;
    watched.add(root);
    new MutationObserver(changed).observe(root, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['aria-label', 'aria-expanded', 'aria-describedby', 'id', 'title', 'alt'],
    });
  }

  function reviewLabels(root) {
    if (copy.reviews_empty) {
      root.querySelectorAll('.jm-no-reviews-state__text').forEach((node) => {
        if (!node.children.length && node.textContent.trim() !== copy.reviews_empty) {
          node.textContent = copy.reviews_empty;
        }
      });
    }
    root.querySelectorAll('.jdgm-write-review-modal__field-group--stars').forEach((group) => {
      const stars = group.querySelector('.jdgm-write-review-modal__stars');
      const error = group.querySelector('.jdgm-write-review-modal__field-error');
      if (!stars || !error) return;
      const previousId = error.id;
      let errorId = reviewErrorIds.get(error);
      if (!errorId) {
        do { errorId = `monoree-review-stars-error-${++reviewErrorSequence}`; }
        while (document.getElementById(errorId));
        reviewErrorIds.set(error, errorId);
      }
      attribute(error, 'id', errorId);
      const descriptions = (stars.getAttribute('aria-describedby') || '').split(/\s+/)
        .filter((id) => id && id !== previousId && id !== 'jdgm-review-stars-error');
      attribute(stars, 'aria-describedby', [...new Set([...descriptions, errorId])].join(' '));
    });
    root.querySelectorAll('select.jdgm-sort-dropdown').forEach((select) => {
      attribute(select, 'aria-label', copy.reviews_sort);
      Array.from(select.labels || []).forEach((label) => {
        if (copy.reviews_sort && label.textContent.trim() === 'Sort reviews by') label.textContent = copy.reviews_sort;
      });
    });
    if (locale === 'pl') {
      root.querySelectorAll('.jm-cluster > .jm-text').forEach((node) => {
        if (node.children.length || !node.parentElement.querySelector('.jm-star-rating')) return;
        const count = node.textContent.trim().match(/^\((\d+) recenzj[aei]\)$/);
        if (count && copy.reviews_count) node.textContent = `(${copy.reviews_count.replace('[count]', count[1])})`;
      });
    }
    root.querySelectorAll('img.jm-reviewer-info__flag[alt]').forEach((node) => {
        const flag = node.alt.match(/^([A-Z]{2}) flag$/);
        if (flag && copy.country_flag) {
          attribute(node, 'alt', copy.country_flag.replace('[country]', countryNames?.of(flag[1]) || flag[1]));
        }
      });
    root.querySelectorAll('[aria-label], [title]').forEach((node) => {
      for (const name of ['aria-label', 'title']) {
        const label = node.getAttribute(name);
        const direct = { 'Sort reviews by': copy.reviews_sort, 'Previous reviews': copy.reviews_previous, 'Next reviews': copy.reviews_next }[label];
        if (direct) attribute(node, name, direct);
        {
          const translated = {
            'Go to previous page': copy.reviews_page_previous,
            'Go to next page': copy.reviews_page_next,
            'Pagination Navigation': copy.reviews_pagination,
            'Verified checkmark': copy.reviews_verified,
          }[label];
          if (translated) attribute(node, name, translated);
          const page = label?.match(/^Go to page (\d+)$/);
          if (page && copy.reviews_page) attribute(node, name, copy.reviews_page.replace('[number]', page[1]));
        }
        const rating = label?.match(/^([\d.,]+) out of ([\d.,]+) stars?$/i)
          || (locale === 'lt' || locale === 'pl'
            ? label?.match(/^([\d.,]+) stars?$/i) : null);
        if (rating && copy.rating) {
          const locale = document.documentElement.lang || 'en';
          const format = (value) => new Intl.NumberFormat(locale).format(Number(value.replace(',', '.')));
          attribute(node, name, copy.rating.replace('[score]', format(rating[1])).replace('[max]', format(rating[2] || '5')));
        }
      }
    });
  }

  function normalizeSchema(value) {
    if (!value || typeof value !== 'object') return;
    if (typeof value['@type'] === 'string' && types[value['@type']]) value['@type'] = types[value['@type']];
    if (Array.isArray(value['@type'])) value['@type'] = value['@type'].map((type) => types[type] || type);
    for (const child of Object.values(value)) {
      if (Array.isArray(child)) child.forEach(normalizeSchema);
      else if (child && typeof child === 'object') normalizeSchema(child);
    }
  }

  function chatLabels() {
    const host = document.querySelector('shopify-chat');
    const outer = host?.shadowRoot;
    if (!outer) return;
    watch(outer, scheduleChat);
    const runtime = outer.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot || outer;
    watch(root, scheduleChat);
    const launcher = root.querySelector('button[part~="activator"]');
    if (launcher) attribute(launcher, 'aria-label', launcher.getAttribute('aria-expanded') === 'true' ? copy.chat_close : copy.chat_open);
    const close = root.querySelector('shopify-chat-icon-button.panel__close');
    if (close) attribute(close, 'label', copy.chat_close);
  }

  function update() {
    scheduled = false;
    const reviews = [...pendingReviews];
    const schemas = [...pendingSchemas];
    const chat = pendingChat;
    pendingReviews.clear();
    pendingSchemas.clear();
    pendingChat = false;
    reviews.forEach(root => { if (root.isConnected) reviewLabels(root); });
    schemas.forEach((script) => {
      if (!script.isConnected || schemaText.get(script) === script.textContent) return;
      try {
        const value = JSON.parse(script.textContent);
        const before = JSON.stringify(value);
        normalizeSchema(value);
        if (value['@type'] === 'Product' && copy.product_name) value.name = copy.product_name;
        const after = JSON.stringify(value);
        if (before !== after) script.textContent = after.replace(/</g, '\\u003c');
      } catch {}
      // Cache the final text, including our normalization. A vendor replacement is processed again.
      schemaText.set(script, script.textContent);
    });
    if (chat) chatLabels();
  }

  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  }

  function scheduleChat() {
    pendingChat = true;
    schedule();
  }

  function discover(root) {
    const each = (selector, callback) => {
      if (root.matches?.(selector)) callback(root);
      root.querySelectorAll(selector).forEach(callback);
    };
    each(widgets, widget => {
      const changed = () => { pendingReviews.add(widget); schedule(); };
      watch(widget, changed);
      changed();
    });
    each(schemaSelector, script => {
      const changed = () => { pendingSchemas.add(script); schedule(); };
      watch(script, changed);
      changed();
    });
    if (root.matches?.('shopify-chat') || root.querySelector('shopify-chat')) scheduleChat();
  }

  new MutationObserver((entries) => {
    for (const entry of entries) for (const node of entry.addedNodes) {
      if (node.nodeType === 1 && (node.matches(`${widgets}, shopify-chat, ${schemaSelector}`) || node.querySelector(`${widgets}, shopify-chat, ${schemaSelector}`))) discover(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
  for (const name of ['shopify-chat', 'shopify-agent-runtime']) customElements.whenDefined(name).then(scheduleChat);
  document.addEventListener('shopify:section:load', event => discover(event.target));
  discover(document);
})();

